import React from 'react'
import {Link} from 'react-router-dom'
import {Container, Carousel} from 'react-bootstrap'
import calendar from './../../src/assets/calendar_opt.png'
import chat from './../../src/assets/chat_opt.png'
import cabinet from './../../src/assets/cabinet_opt.png'

const Homepage = props => {
	return (
			<div className="homeMain">
				<section className="homePageMain d-flex align-items-center flex-column">
					<Container className="mt-auto">
							<div className="">
							<h1 className="py-2 text-white">
								Unlock Whole Home Maintenance.
							</h1>
							<h3 className="text-white">
								Have all the benefits of home ownership without the inconveniences.
							</h3>
							<div className="py-4">
								<Link to="/plans">
									<button className="btn mx-2">TRY</button>
								</Link>
								<a href="#moreInfo">
									<button className="btn btn-alt mx-2">LEARN MORE</button>
								</a>
							</div>
							</div>
							
					</Container>
						<div className="mt-auto scroll"><svg xmlns="http://www.w3.org/2000/svg" className="scrollIcon " fill="none" viewBox="0 0 24 24" stroke="currentColor">
							<path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7" />
							</svg>
						</div>
				</section>
				<section className="more text-center pb-5" id="moreInfo">
					<Container>
						<div className="headSection pb-3 " >
							<h2 className="py-3">
								How it Works
							</h2>
							<div className="d-flex justify-content-center">
								<div className="hrLine"></div>
							</div>
						</div>
						<div className="row py-3 ">
							<div className="col-md-6 col-lg-4 my-3 d-flex mx-auto">
								<div className="card">
									<div className="card-body flex-fill">
										<h4 className="card-title">Alleviate</h4>
										<p className="card-text">No need to worry about your seasonal maintenance and chore lists anymore. Place your home care on auto pilot with our repeatable planning and calendars. </p>
									</div>
									<Link to="/plans">
										<div className="card-footer text-uppercase">
											See how it works
										</div>
									</Link>
								</div>
							</div>
							<div className="col-md-6 col-lg-4 my-3 d-flex mx-auto">
								<div className="card">
									<div className="card-body flex-fill">
										<h4 className="card-title">Convenient</h4>
										<p className="card-text">Consolidate over a dozen services into a single, reliable subscription. Receive a broad range of services for one simple fee. </p>
									</div>
									<Link to="/plans">
										<div className="card-footer text-uppercase">
											See our list of services
										</div>
									</Link>
								</div>
							</div>
							<div className="col-md-6 col-lg-4 my-3 d-flex mx-auto">
								<div className="card">
									<div className="card-body flex-fill">
										<h4 className="card-title">Simple</h4>
										<p className="card-text">We provide a professional service suite to conscientious homeowners on one secure platform—no gimmicks, great service. </p>
									</div>
									<Link to="/plans">
										<div className="card-footer text-uppercase">
										See how easy it is
										</div>
									</Link>
								</div>
							</div>

						</div>
						
					</Container>
				</section>
				<section className="features text-center pb-5">
					<Container>
						<div className="headSection pb-3 " >
							<h2 className="py-3">
								Unique Features
							</h2>
							<div className="d-flex justify-content-center">
								<div className="hrLine"></div>
							</div>
						</div>
						<Carousel>
							<Carousel.Item>
								<img
								className="d-block w-50 mx-auto"
								src={calendar}
								alt="Calendar/ Appointments"
								/>
								<Carousel.Caption className="mx-auto">
								<h3>Calendar of Appointments</h3>
								<p>Quickly review when each service will be done on your private calendar.</p>
								</Carousel.Caption>
							</Carousel.Item>
							<Carousel.Item>
								<img
								className="d-block w-50 mx-auto"
								src={chat}
								alt="Chat operation"
								/>

								<Carousel.Caption>
								<h3>Instant Feedback</h3>
								<p>Quickly connect with any service you need to get real-time help.</p>
								</Carousel.Caption>
							</Carousel.Item>
							<Carousel.Item>
								<img
								className="d-block w-50 mx-auto"
								src={cabinet}
								alt="Customer Gelocation"
								/>

								<Carousel.Caption>
								<h3>Filing Cabinet</h3>
								<p>A place to store all your invoices, receipts, and quotes</p>
								</Carousel.Caption>
							</Carousel.Item>
						</Carousel>
						
						
					</Container>
				</section>
















				<section className="faq text-left py-5" id="faq">
					<Container>
						<div className="headSection pb-3 text-center" >
							<h2 className="py-3">
								FAQ
							</h2>
							<div className="d-flex justify-content-center">
								<div className="hrLine"></div>
							</div>
						</div>
						<div className="row py-3 d-flex justify-content-center">
							<div className="col-md-6 col-lg-6 col-xs-12 my-3">
								<h4>Unlock better living.</h4> 
								<p>Subscribe to a new kind of home service, one that takes homeowner responsibilities from you and
									gives you time in return. Time you spend doing more important things. As soon as you subscribe
									and fill out some information about your home, you are done. Watch us fill your calendar with
									appointments and schedule your maintenance while you relax.</p>
							</div>
							<div className="col-md-6 col-lg-6 col-xs-12 my-3 livingImg">
							</div>
						</div>
						<div className="row py-3 d-flex justify-content-center">
							<div className="col-md-6 col-lg-6 col-xs-12 my-3 valueImg">
							</div>
							<div className="col-md-6 col-lg-6 col-xs-12 my-3">
								
								<h4>Stop paying for access, start paying for value.</h4> 
								<p>Whether you opt for a basic package of services or sign up for them all, Chore Door replaces
									dozens of service providers in one easy location. Contacting contractors through other websites,
									internet searches, or by phone requires proper vetting, multiple estimates, deposits, payments,
									etc. Chore Door takes that burden off you.</p>
							</div>
						</div>
						<div className="row py-3 d-flex justify-content-center">
							<div className="col-md-6 col-lg-6 col-xs-12 my-3">
								<h4>Have confidence.</h4> 
								<p>All transactions are done through Chore Door, no third party charges to worry about. All payments
									are held until work is completed, giving you the assurance the job will be done quickly and
									correctly. Chore Door is actively participating in your service and service is our top priority.</p>
							</div>
							<div className="col-md-6 col-lg-6 col-xs-12 my-3 confidenceImg">
							</div>
						</div>
						<div className="row py-3 d-flex justify-content-center">
							<div className="col-md-6 col-lg-6 col-xs-12 my-3 unlockImg">
							</div>
							<div className="col-md-6 col-lg-6 col-xs-12 my-3">
								
								<h4>Don’t make a commitment.</h4> 
								<p>Use Chore Door as your life requires. Of course, a whole year worth of maintenance is ideal, but
									sometimes life changes. Gone for a few months, have a business that requires maintenance, or
									aging relatives? Chore Door has an easy, no commitment subscription that allows for all situations including multiple properties and short-term use.</p>
							</div>
						</div>
						<div className="row py-3 d-flex justify-content-center">
							<div className="col-md-6 col-lg-6 col-xs-12 my-3">
								<h4>Choose la carte pricing.</h4> 
								<p>Chore Door is customizable, beyond the base subscription, opt for services that fit you individual
									needs. In addition to fixed price services such as cleaning and holiday lights; your yard size, house size, and number of levels can be configured to fit your home and the service it requires.</p>
							</div>
							<div className="col-md-6 col-lg-6 col-xs-12 my-3 cartImg">
							</div>
						</div>
						<div className="row py-3 d-flex justify-content-center">
							<div className="col-md-6 col-lg-6 col-xs-12 my-3 callImg">
							</div>
							<div className="col-md-6 col-lg-6 col-xs-12 my-3">
								
								<h4>Retain on call service providers.</h4> 
								<p>Your home can experience a maintenance emergency any time day or night, with your
									subscription you have direct access to the most reputable qualified service providers available to provide you a quote and service ASAP. Or if you have a deck that won’t build itself, Chore Door is ready to serve your needs.</p>
							</div>
						</div>
						<div className="row py-3 d-flex justify-content-center">
							<div className="col-md-6 col-lg-6 col-xs-12 my-3">
								<h4>Care about your privacy.</h4> 
								<p>Chore Door will not collect your personal information for the purpose of marketing or selling to
									marketers. Ever. All service providers are vetted by Chore Door and are required to be licensed and insured.</p>
							</div>
						
							<div className="col-md-6 col-lg-6 col-xs-12 my-3 lockImg">
							</div>
						</div>
						<div className="row py-3 d-flex justify-content-center">
							<div className="col-md-6 col-lg-6 col-xs-12 my-3 toolsImg">
								
							</div>
							<div className="col-md-6 col-lg-6 col-xs-12 my-3">
								
								<h4>Ditch your tools.</h4> 
								<p>Lawn mower, snow blower, shovels, rakes, line trimmer, snow shovel, and the list keeps on going.
									Thousands of dollars spent to do a job most homeowners don’t enjoy doing. Subscribe to Chore
									Door and stop spending on tools.</p>
							</div>
						</div>
						
					</Container>
				</section>
			</div>
			
	)
}
export default Homepage